export function getAutomaticGlobalProperties() {
  return __getAutomaticGlobalProperties(window);
}
export function __getAutomaticGlobalProperties(window) {
  if (!window) return {};
  const {
    location: {
      href,
      hostname,
      pathname
    },
    document: {
      title
    }
  } = window;
  return {
    'Full URL': truncate(href),
    'Page Title': truncate(title),
    'Hostname': hostname,
    'Page Path': pathname
  };
}
function truncate(text) {
  return (text === null || text === void 0 ? void 0 : text.length) > 1000 ? text.substring(0, 1000) : text;
}
//# sourceMappingURL=windowPropertiesHelper.js.map